module.exports = __webpack_public_path__ + "static/media/avatar.165eb227.png";